// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"7dceaf62","453":"c4ad9a6a","880":"30d9e7fa"}[chunkId] + ".chunk.js";
};